'use client';

import { c as _c } from "react/compiler-runtime";
import wordEndings from '@lib/tools/_word-endings';
import { useParams } from 'next/navigation';
import { isCompletedQueue } from '../../constants';
import style from './VisualInfo.module.scss';
const PieceOfInfo = t0 => {
  const $ = _c(5);
  const {
    info
  } = t0;
  let t1;
  if ($[0] !== info) {
    t1 = <span className={style.visualInfo__text}>{info}</span>;
    $[0] = info;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={style.visualInfo__dot} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function VisualInfo(t0) {
  const $ = _c(53);
  const {
    activeFloor,
    activeFlat,
    data,
    activeBulk
  } = t0;
  const {
    houseId,
    bulkId,
    floorId
  } = useParams();
  let t1;
  if ($[0] !== data?.bulks || $[1] !== data?.flats) {
    t1 = (bulkId_0, type) => {
      const bulk_0 = data?.bulks?.find(bulk => bulk.id === bulkId_0);
      const flatsLength = data?.flats?.filter(item => item.bulk?.id === bulkId_0).length;
      if (!bulk_0) {
        return null;
      }
      switch (type) {
        case "keyDate":
          {
            return bulk_0.keyDate;
          }
        case "buildingPhase":
          {
            return bulk_0.buildingPhase;
          }
        case "floorsCount":
          {
            return bulk_0.floorsCount;
          }
        case "decoration":
          {
            return bulk_0.decoration;
          }
        case "name":
          {
            return bulk_0.name;
          }
        case "flatsLength":
          {
            return flatsLength;
          }
        default:
          {
            return null;
          }
      }
    };
    $[0] = data?.bulks;
    $[1] = data?.flats;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getInfo = t1;
  let t2;
  if ($[3] !== activeBulk || $[4] !== getInfo) {
    t2 = getInfo(activeBulk, "keyDate")?.replace(/-/g, ".").split(".").reverse().join(".");
    $[3] = activeBulk;
    $[4] = getInfo;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const keyDate = t2;
  let t3;
  if ($[6] !== activeBulk || $[7] !== getInfo || $[8] !== keyDate) {
    t3 = isCompletedQueue(getInfo(activeBulk, "buildingPhase")) ? "\u0414\u043E\u043C \u0441\u0434\u0430\u043D" : `Ключи до ${keyDate}`;
    $[6] = activeBulk;
    $[7] = getInfo;
    $[8] = keyDate;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const completionInfo = t3;
  let t4;
  if ($[10] !== floorId || $[11] !== houseId) {
    t4 = houseId && !floorId && <PieceOfInfo info={houseId === "1" ? "\u041E\u0447\u0435\u0440\u0435\u0434\u044C 1" : "\u041E\u0447\u0435\u0440\u0435\u0434\u044C 2"} />;
    $[10] = floorId;
    $[11] = houseId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== activeBulk || $[14] !== bulkId || $[15] !== getInfo) {
    t5 = bulkId && <PieceOfInfo info={getInfo(activeBulk, "name")} />;
    $[13] = activeBulk;
    $[14] = bulkId;
    $[15] = getInfo;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== activeFloor || $[18] !== bulkId || $[19] !== completionInfo || $[20] !== floorId) {
    t6 = (!floorId && activeFloor || !bulkId) && <PieceOfInfo info={completionInfo} />;
    $[17] = activeFloor;
    $[18] = bulkId;
    $[19] = completionInfo;
    $[20] = floorId;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== activeBulk || $[23] !== activeFloor || $[24] !== bulkId || $[25] !== floorId || $[26] !== getInfo) {
    t7 = (!activeFloor && bulkId || !bulkId) && <PieceOfInfo info={`${floorId ?? getInfo(activeBulk, "floorsCount")} ${floorId ? "\u044D\u0442\u0430\u0436" : "\u044D\u0442\u0430\u0436\u0435\u0439"}`} />;
    $[22] = activeBulk;
    $[23] = activeFloor;
    $[24] = bulkId;
    $[25] = floorId;
    $[26] = getInfo;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== activeFlat || $[29] !== floorId) {
    t8 = floorId && activeFlat && <PieceOfInfo info={`'№'${activeFlat}`} />;
    $[28] = activeFlat;
    $[29] = floorId;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== completionInfo || $[32] !== floorId) {
    t9 = floorId && <span>{completionInfo}</span>;
    $[31] = completionInfo;
    $[32] = floorId;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  if ($[34] !== activeBulk || $[35] !== activeFloor || $[36] !== bulkId || $[37] !== floorId || $[38] !== getInfo) {
    t10 = bulkId && !floorId && !activeFloor && <PieceOfInfo info={`${getInfo(activeBulk, "flatsLength")} ${wordEndings(getInfo(activeBulk, "flatsLength"))}`} />;
    $[34] = activeBulk;
    $[35] = activeFloor;
    $[36] = bulkId;
    $[37] = floorId;
    $[38] = getInfo;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  if ($[40] !== activeBulk || $[41] !== floorId || $[42] !== getInfo) {
    t11 = !floorId && <span className={style.visualInfo__whitebox}>{getInfo(activeBulk, "decoration") === "whitebox" ? "White Box" : getInfo(activeBulk, "decoration")}</span>;
    $[40] = activeBulk;
    $[41] = floorId;
    $[42] = getInfo;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  let t12;
  if ($[44] !== t10 || $[45] !== t11 || $[46] !== t4 || $[47] !== t5 || $[48] !== t6 || $[49] !== t7 || $[50] !== t8 || $[51] !== t9) {
    t12 = <><div className={style.visualInfo}>{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}</div></>;
    $[44] = t10;
    $[45] = t11;
    $[46] = t4;
    $[47] = t5;
    $[48] = t6;
    $[49] = t7;
    $[50] = t8;
    $[51] = t9;
    $[52] = t12;
  } else {
    t12 = $[52];
  }
  return t12;
}
export default VisualInfo;